import type { RoleConfig } from '../types.js';

export const survivor: RoleConfig = {
  id: 'survivor',
  faction: 'solo',
  title: { ru: 'Уцелевший', uk: 'Уцілілий' },
  latin: 'SURVIVOR',
  number: '27',
  accent: '#d6c87a',
  ability: {
    ru: 'Имеет два бронежилета — может надеть на себя ночью. Побеждает, если выживет до конца.',
    uk: 'Має два бронежилети — може одягнути на себе вночі. Перемагає, якщо виживе до кінця.',
  },
  abilities: [
    {
      key: 'vest',
      phase: 'night',
      cadence: 'every-night',
      shape: 'targetless',
      targetless: true,
      charges: 2,
    },
  ],
  victory: { type: 'survive' },
};
